"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dom = void 0;
const element_id_exception_1 = require("../exceptions/element-id.exception");
const tokenization_providers_constants_1 = require("../constants/tokenization-providers.constants");
const vgs_config_1 = require("../config/vgs.config");
const spreedly_config_1 = require("../config/spreedly.config");
class Dom {
    constructor() {
        this.defaultStyles = `
    width: 100%;
    height: 100%;
    border: 0px;
    padding: 0px;
    background: transparent;
  `;
    }
    createHTMLInputText(config) {
        const parentContainer = this.getParentContainer(config.parentId);
        const inputElement = document.createElement('input');
        inputElement.setAttribute('id', this.generateFieldElementId(config.parentId));
        inputElement.setAttribute('type', 'text');
        inputElement.setAttribute('name', config.name);
        inputElement.setAttribute('placeholder', config.placeholder);
        inputElement.setAttribute('style', this.defaultStyles);
        parentContainer.appendChild(inputElement);
        return inputElement;
    }
    createHTMLInputSelect(config) {
        const parentContainer = this.getParentContainer(config.parentId);
        const selectElement = document.createElement('select');
        selectElement.setAttribute('id', this.generateFieldElementId(config.parentId));
        selectElement.setAttribute('name', config.name);
        selectElement.setAttribute('style', this.defaultStyles);
        selectElement.value = config.options.length ? config.options[0].value : '';
        config.options.forEach(option => {
            const optionElement = document.createElement('option');
            optionElement.value = option.value;
            optionElement.textContent = option.label;
            selectElement.appendChild(optionElement);
        });
        parentContainer.appendChild(selectElement);
        return selectElement;
    }
    createHTMLInputCheckbox(config) {
        const parentContainer = this.getParentContainer(config.parentId);
        const inputElement = document.createElement('input');
        inputElement.setAttribute('id', this.generateFieldElementId(config.parentId));
        inputElement.setAttribute('type', 'checkbox');
        inputElement.setAttribute('name', config.name);
        parentContainer.prepend(inputElement);
        return inputElement;
    }
    deleteElementFromParent(parentId) {
        const parentContainer = this.getParentContainer(this.generateFieldElementId(parentId));
        parentContainer.remove();
    }
    loadVGSScript() {
        return this.buildScript(tokenization_providers_constants_1.TokenizationProviders.VGS, vgs_config_1.VGS_SCRIPT_URL);
    }
    loadSpreedlyScript() {
        return this.buildScript(tokenization_providers_constants_1.TokenizationProviders.SPREEDLY, spreedly_config_1.SPREEDLY_SCRIPT_URL);
    }
    generateFieldElementId(id) {
        return `${id}-field`;
    }
    buildScript(source, src) {
        return new Promise((resolve, reject) => {
            const element = document.createElement('script');
            const scriptId = `rappi-${source}`;
            element.type = 'text/javascript';
            element.src = src;
            element.async = true;
            element.id = scriptId;
            if (!document.getElementById(scriptId)) {
                const [documentHead] = document.getElementsByTagName('head');
                documentHead.appendChild(element);
                element.onload = (() => resolve());
                element.onerror = (() => {
                    element.remove();
                    reject();
                });
            }
            else {
                resolve();
            }
        });
    }
    getParentContainer(parentContainerId) {
        const container = document.getElementById(parentContainerId);
        if (!container) {
            throw new element_id_exception_1.ElementIdException(parentContainerId);
        }
        return container;
    }
}
exports.Dom = Dom;
